interface GenericObject {
  [key: string]: any
}

export function createLookupMap<T extends GenericObject, K extends keyof T>(
  arr: T[] | null,
  keyName: K,
): Record<T[K], T> | null {
  if (!arr) {
    return null
  }
  const result: Record<T[K], T> = {} as Record<T[K], T>
  for (const item of arr) {
    if (item) {
      const key = item[keyName]
      result[key] = item
    }
  }
  return result
}
